<template>
    <li data-mobile-menu-item>
        <a href="" data-mobile-menu-trigger>
            Industry Catalog
            <svg width="7" height="11">
            <path
                d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"
            />
            </svg>
        </a>
        <div class="mobile-menu__links-panel" data-mobile-menu-panel>
            <div class="mobile-menu__panel mobile-menu__panel--hidden">
            <div class="mobile-menu__panel-header">
                <button class="mobile-menu__panel-back" type="button">
                <svg width="7" height="11">
                    <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z" />
                </svg>
                </button>
                <div class="mobile-menu__panel-title">Industry Catalog</div>
            </div>
            <div class="mobile-menu__panel-body">
                <ul class="mobile-menu__links">
                    <!--  @click.prevent="getChildren(imenu)" -->
                    <li data-mobile-menu-item v-for="(imenu, index) in industrial_menus" :key="index"  @click.prevent="getChildren(imenu)">
                        <a data-mobile-menu-trigger href="#">
                            {{ imenu.QGRDSC }}
                            <svg width="7" height="11">
                                <path
                                d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9	C-0.1,9.8-0.1,10.4,0.3,10.7z" />
                            </svg>
                        </a>
                        <div class="mobile-menu__links-panel" data-mobile-menu-panel>
                            <div class="mobile-menu__panel mobile-menu__panel--hidden">
                                <div class="mobile-menu__panel-header">
                                    <button class="mobile-menu__panel-back" type="button">
                                        <svg width="7" height="11">
                                        <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z" />
                                        </svg>
                                    </button>
                                    <div class="mobile-menu__panel-title">{{imenu.QGRDSC}}</div>
                                </div>
                                <div class="mobile-menu__panel-body">
                                    <ul class="mobile-menu__links">
                                        <li data-mobile-menu-item v-for="(subcat, index2) in imenu.SUBCAT" :key="index2">
                                            <!-- <router-link data-mobile-menu-trigger :to="'/category/2/' + subcat.QGRDSC">
                                                {{subcat.QCAT}}
                                            </router-link> -->

                                            <a href="#" class="megamenu-links__item-link" @click.prevent="checkVehicle(imenu.QGROUP, subcat.QGRDSC)">
                                                {{ subcat.QCAT }} 
                                            </a>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
            </div>
        </div>
    </li>

<base-dialog title="Invalid Search" @close="closeDialog" :open="searchvalid === false">
    <template #default>
      <p>{{ searchErrorNote }}</p>
    </template>
</base-dialog>

</template>
<script>
import { mapGetters } from 'vuex';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            searchvalid: true,

            selectedyear: 0,
            selectedmake: null,
            selectedmodel: null,
        };
    },

    props: {
        industrial_menus: {
            type: Array,
            required: true
        },
    },
    emits: [
        'select_vehicle'
    ],
    methods: {
        getChildren(group) {
            this.selectedyear = this.$store.getters['vehicle/selectedyear'];
            this.selectedmake = this.$store.getters['vehicle/selectedmake'];
            this.selectedmodel = this.$store.getters['vehicle/selectedmodel'];

            // if (this.selectedyear === 0 || this.selectedmake === '' || this.selectedmodel === '') {
            //     this.searchvalid = false;
            //     return;
            // }
            // console.log(group);
            if(group.SUBCAT.length == 0) {
                this.getIndustrialChild(group.QGROUP).then((resdata) => {
                let children = [];
                for (const i in resdata.data.webroutine.lists.CATSD.entries) {
                    const obj2 = resdata.data.webroutine.lists.CATSD.entries[i];
                    children.push({
                        QCAENR: obj2.QCAENR,
                        QCAT: obj2.QCAT,
                        QGRDSC: obj2.QGRDSC,
                        QGRDSCR: obj2.QGRDSCR,
                        QGROUP: obj2.QGROUP,
                    });
                }
                group.SUBCAT  = children;
                });
                // console.log(group);
            }
        },

        getIndustrialChild(groupID) {
            const sfCatalog = this.$store.getters['storeCatalog'];
            const catpn = this.$store.getters['storeConfigID'];
            if(sfCatalog == 'WHI'){
                this.childURI = this.$store.getters['api/vehicle_categories_uri'];
            }else{
                this.childURI = this.$store.getters['api/vehicle_type_uri'];
            }

            return axiosvl.post(this.childURI, {
                webroutine: {
                    context: {
                        "session-key-method": "hidden",
                    },
                    fields: {
                        EHCUST: {
                            value: "DMS",
                        },
                        CATPN: {"value": catpn},
                        QGROUP: {"value": groupID}
                    },
                },
            })
            .then((response) => {
                return response;
            })
            .catch(function (error) {
                console.log("error - " + error);
                // this.isloading = false;
            });
        },

        checkVehicle(qgroup, qtype){
            // console.log('qgroup = ' + qgroup);
            // console.log('qtype = ' + qtype);
            const qgroups = [qgroup];
            const qtypes = [qtype];

            this.selectedyear = this.$store.getters['vehicle/selectedyear'];
            this.selectedmake = this.$store.getters['vehicle/selectedmake'];
            this.selectedmodel = this.$store.getters['vehicle/selectedmodel'];

            this.$store.dispatch('vehicle/setSelectedCategories', qtypes);
            this.$store.dispatch('vehicle/setSelectedGroups', qgroups);

            if (this.selectedyear === 0 || this.selectedmake === '' || this.selectedmodel === '') {        
                this.$emit('select_vehicle');
                return false;
            }else{
                this.$router.push("/search-results");
            }
        },
    
        
        closeDialog() {
            console.log('close dialog clicked');
            this.searchvalid = true;
        }
    },
    computed: {
        ...mapGetters([
            "storeCatalog"
        ]),
        searchErrorNote() {
            if (this.storeCatalog === 'WHI') {
                return 'Please select values for Year/Make/Model/Engine to conduct your search.';
            } else if (this.storeCatalog === 'partslink') {
                return 'Please select values for Year/Make/Model to conduct your search.';
            }
            return '';
        }
    },

    updated() {
        // console.log(this.industrial_menus);
    }
};
</script>